
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../Hooks/useToast';
import { useUser } from '../Hooks/useUser';
import { useAppDispatch, useAppSelector } from '../Redux/store';
import { KaziModal } from './Kazi/KaziModal';
import { setShowUnverifiedModal } from '../Redux/slices/GlobalModalSlice';

interface UnverifiedModalProps {}
export const UnverifiedModal = ({}:UnverifiedModalProps ) => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    /* ******************** Variables ******************** */
    const open = useAppSelector( state => state.GlobalModal.showUnverifiedModal);
    /* ******************** Functions ******************** */
    const handleClose = () => {
        dispatch(setShowUnverifiedModal(false));
        navigate('/dashboard');
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            handleClose={handleClose}
            title='Your account is unverified'
            content={
                <>
                    <Typography>Verify your account to access this page</Typography>
                </>
            }
            actions={[
                <Button variant='contained' onClick={handleClose}>Return to dashboard</Button>
            ]}
        />
    )
}
